<template>
  <div
    aria-hidden="true"
    aria-labelledby="myModalLabel"
    :class="[{ big_modal: isBig, hide: startClosed, fade: startClosed }, 'modal']"
    role="dialog"
    v-if="isLoaded"
  >
    <div class="modal-header">
      <button v-if="!modal" aria-hidden="true" class="close" data-dismiss="modal" type="button" @click="close()">
        <i class="fa-light fa-xmark"></i>
      </button>
      <h3 class="title" id="myModalLabel4">
        <slot name="header"></slot>
      </h3>
    </div>
    <div class="modal-body">
      <slot></slot>
    </div>
    <div class="modal-footer adv">
      <button v-if="!modal" aria-hidden="true" class="secondary" data-dismiss="modal" @click="close">
        <slot name="close">{{ i18nJS['command.close'] }}</slot>
      </button>
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
import { LabelApi } from '@/epersonam/mixins/labels.js';

export default {
  name: 'vModal',
  mixins: [LabelApi],
  props: {
    isBig: Boolean,
    modal: Boolean,
    startClosed: { type: Boolean, default: true },
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  async mounted() {
    this.neededlabels = ['command.close'];
    await this.setupLabels();
    this.isLoaded = true;

    $('[aria-labelledby="myModalLabel"]').on('hidden.bs.modal', this.close);
  },
  methods: {
    close() {
      this.$emit('modalClosed');
    },
  },
};
</script>

<style scoped>
.title {
  text-align: left;
}
</style>
